import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RekapPromoPage } from './rekap-promo.page';

const routes: Routes = [
  {
    path: '',
    component: RekapPromoPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RekapPromoPageRoutingModule {}
